export default __webpack_public_path__ + "static/media/flag-vi.58ff7047.svg";